import { buildApiHeaders, resolveInternalApiUrl } from '@/utils/apiHeaders'

export interface BugAttachmentFileInfo {
  id?: string | number
  name?: string
  file?: File | null
  status?: string
}

export async function uploadPendingBugAttachments(
  bugId: string,
  fileList: BugAttachmentFileInfo[],
  onError?: (message: string) => void
): Promise<number> {
  const filesToUpload = fileList.filter((f) => f.file)
  if (filesToUpload.length === 0) return 0

  const url = resolveInternalApiUrl(`/bugs/${bugId}/attachments`)
  const headers = buildApiHeaders({ url, includeAuth: true, isFormData: true })

  let successCount = 0
  for (const fileInfo of filesToUpload) {
    if (!fileInfo.file) continue
    const formData = new FormData()
    formData.append('files', fileInfo.file)
    try {
      const response = await fetch(url, { method: 'POST', headers, body: formData })
      if (!response.ok) {
        const errBody = await response.json().catch(() => ({}))
        throw new Error(
          errBody.message ||
            errBody.error?.message ||
            `Upload failed (${response.status})`
        )
      }
      const data = await response.json()
      if (data?.urls?.length) successCount += data.urls.length
    } catch (err) {
      const message =
        err instanceof Error ? err.message : `Failed to upload "${fileInfo.name}"`
      console.error('Attachment upload failed:', err)
      onError?.(message)
    }
  }
  return successCount
}
